import { merchantApi } from '../setup/setupMerchantApi';
import { ChartsPointsType, FilterObjectType } from './type';

export const getActiveUsers = (
  merchantId: number,
  filter: FilterObjectType
): Promise<ChartsPointsType> =>
  merchantApi
    .get(`/merchant/merchants/${merchantId}/dwh-analytics/chart/login_active_users_by_date`, {
      params: filter
    })
    .then((res) => {
      return res.data;
    });

export const getAuthMethods = (
  merchantId: number,
  filter: FilterObjectType
): Promise<ChartsPointsType> =>
  merchantApi
    .get(`/merchant/merchants/${merchantId}/dwh-analytics/chart/login_auth_methods`, {
      params: filter
    })
    .then((res) => res.data);

export const getCountries = (
  merchantId: number,
  filter: FilterObjectType
): Promise<ChartsPointsType> =>
  merchantApi
    .get(`/merchant/merchants/${merchantId}/dwh-analytics/chart/login_users_by_country`, {
      params: filter
    })
    .then((res) => res.data);
